export const cyberkongzNFTs = [
  
  {
    "id": "cyberkongz-11",
    "name": "CyberKongz #11",
    "image": "https://ipfs.io/ipfs/QmbVXhyh9fSHCEE5E7cnF4K867dtTKGkrYxJRXwVCQ8K9D",
    "price": "6.8 ETH"
  },
  {
    "id": "cyberkongz-862",
    "name": "CyberKongz #862",
    "image": "https://ipfs.io/ipfs/QmTBrrqLqE5GnHRPAmGWmLBYKUjKZLJE4yfuLbqdPumgzt",
    "price": "5.2 ETH"
  },
  {
    "id": "cyberkongz-971",
    "name": "CyberKongz #971",
    "image": "https://ipfs.io/ipfs/QmZG9twKsCeZzGrfQs75s5XcaKUDoicMcCvoFZVUfKxHcS",
    "price": "7.1 ETH"
  },
  {
    "id": "cyberkongz-536",
    "name": "CyberKongz #536",
    "image": "https://ipfs.io/ipfs/QmetCy1hewuR92o577kZ525rt7AZBj9XDGRSw4EGgBadz8",
    "price": "4.9 ETH"
  },
  {
    "id": "cyberkongz-645",
    "name": "CyberKongz #645",
    "image": "https://ipfs.io/ipfs/QmagiC96ABAwTsNZevEp2zMuY2cuvQBpJKgbJHNGPAU4hb",
    "price": "6.3 ETH"
  },
  {
    "id": "cyberkongz-392",
    "name": "CyberKongz #392",
    "image": "https://ipfs.io/ipfs/QmUd38ZMjMJLskvWLctgCR97JCRDyapeysJ82E7tyGCedU",
    "price": "5.7 ETH"
  },
  {
    "id": "cyberkongz-276",
    "name": "CyberKongz #276",
    "image": "https://ipfs.io/ipfs/Qma6VqqjV76x8Fi24EVkbm4E4NktVtbhDnLir7SijgFM2b",
    "price": "7.3 ETH"
  },
  {
    "id": "cyberkongz-374",
    "name": "CyberKongz #374",
    "image": "https://ipfs.io/ipfs/QmStSMaJ5QdirajReNBsji6FZsM8UAf5f3MPM64V8jMn26",
    "price": "4.7 ETH"
  },
  {
    "id": "cyberkongz-307",
    "name": "CyberKongz #307",
    "image": "https://ipfs.io/ipfs/QmfKmnXA1HTvquwF13FkLu36s6CrmNW4JWHgrvanCJ8sin",
    "price": "6.5 ETH"
  },
  {
    "id": "cyberkongz-157",
    "name": "CyberKongz #157",
    "image": "https://ipfs.io/ipfs/QmYZLK7dqe2oKkrcu9KHpdqwhV9RsomkVFWCpSSWP6Nz7r",
    "price": "5.4 ETH"
  },
  {
    "id": "cyberkongz-552",
    "name": "CyberKongz #552",
    "image": "https://ipfs.io/ipfs/Qmaf6zB7zZ65QzeeUwvFSLpYGkFoNvimPrEuVkD7Uw8sy1",
    "price": "7.0 ETH"
  },
  {
    "id": "cyberkongz-871",
    "name": "CyberKongz #871",
    "image": "https://ipfs.io/ipfs/QmShMw3GUSETTqfsSGMgNXxpnnHehT2GE5dqh1uaKF5gRH",
    "price": "4.8 ETH"
  },
  {
    "id": "cyberkongz-830",
    "name": "CyberKongz #830",
    "image": "https://ipfs.io/ipfs/QmQfGFh5hTwd6UnNUPfQV4Y1HPZFV2X3LyELicLjCpdq9g",
    "price": "6.7 ETH"
  },
  {
    "id": "cyberkongz-919",
    "name": "CyberKongz #919",
    "image": "https://ipfs.io/ipfs/QmQzHa84rvwm5DUpwnNNTygqWnmCPur9mSDimdVDcPpH6L",
    "price": "5.6 ETH"
  },
  {
    "id": "cyberkongz-465",
    "name": "CyberKongz #465",
    "image": "https://ipfs.io/ipfs/Qma4gCCrt7U8ox1ktzBsMLNvjNPyY7XZ5RBFirRMBdn8JZ",
    "price": "7.2 ETH"
  },
  {
    "id": "cyberkongz-771",
    "name": "CyberKongz #771",
    "image": "https://ipfs.io/ipfs/QmUVYLYFbiGL87hajuNdmQY8fRuu5ooDwM8rKARHk975Pr",
    "price": "4.6 ETH"
  },
  {
    "id": "cyberkongz-990",
    "name": "CyberKongz #990",
    "image": "https://ipfs.io/ipfs/Qmd83UzSAGL5icoCUrF1amBborb1hov8szWmN5BxJV8Y3U",
    "price": "6.4 ETH"
  },
  {
    "id": "cyberkongz-927",
    "name": "CyberKongz #927",
    "image": "https://ipfs.io/ipfs/QmUbFsJi86UFfgKEGzFUMHgCUv4jXRPJQAJ6UymyeoBfmc",
    "price": "5.3 ETH"
  },
  {
    "id": "cyberkongz-587",
    "name": "CyberKongz #587",
    "image": "https://ipfs.io/ipfs/QmdYTGSUjYxQvPCxYyEtm8R2RmxXZXPXNgdGNSgSmUGgkY",
    "price": "7.4 ETH"
  },
  {
    "id": "cyberkongz-447",
    "name": "CyberKongz #447",
    "image": "https://ipfs.io/ipfs/QmNqyZw6pNjUN8RWbMNQBNR2Fc3vDCz9gb8kuDYm9sC7gx",
    "price": "4.9 ETH"
  },
  {
    "id": "cyberkongz-630",
    "name": "CyberKongz #630",
    "image": "https://ipfs.io/ipfs/QmPjNm6FZHyNh8yzxwuKmfNW9itaLCCTEbVeZeBpEERx37",
    "price": "6.6 ETH"
  },
  {
    "id": "cyberkongz-974",
    "name": "CyberKongz #974",
    "image": "https://ipfs.io/ipfs/QmU1cHihpvdaFLLDvWjsZp9sKyk3zz8Sj8WkJHAhfJa2vm",
    "price": "5.5 ETH"
  },
  {
    "id": "cyberkongz-680",
    "name": "CyberKongz #680",
    "image": "https://ipfs.io/ipfs/QmTT465PtJALFCDmHnXga19ebbun2i4r2zM9nbYtLR8dRL",
    "price": "7.1 ETH"
  },
  {
    "id": "cyberkongz-149",
    "name": "CyberKongz #149",
    "image": "https://ipfs.io/ipfs/QmPfDKr3DPmChrpFjWtCokw71oinuSa3RiK2wsZNYUMoJT",
    "price": "4.7 ETH"
  },
  {
    "id": "cyberkongz-969",
    "name": "CyberKongz #969",
    "image": "https://ipfs.io/ipfs/QmQGA11xCZKQfRH2qCs9zD9Stu9i6ZUMWZBFzVdMRLJ1BH",
    "price": "6.3 ETH"
  },
  {
    "id": "cyberkongz-316",
    "name": "CyberKongz #316",
    "image": "https://ipfs.io/ipfs/QmZikYtag8gyMAWxm9pSM6nvTXzaVtgnT2fwox8da1NrR7",
    "price": "5.2 ETH"
  },
  {
    "id": "cyberkongz-167",
    "name": "CyberKongz #167",
    "image": "https://ipfs.io/ipfs/QmPEEWQK8sWngZbMrr35wReZ2RypxoF46Xyabc7PZZRCGt",
    "price": "7.3 ETH"
  },
  {
    "id": "cyberkongz-171",
    "name": "CyberKongz #171",
    "image": "https://ipfs.io/ipfs/QmTXg4d2UyyTkmivifehD9FXw5gB97TCnWt78XFKUWCCzS",
    "price": "4.8 ETH"
  },
  {
    "id": "cyberkongz-979",
    "name": "CyberKongz #979",
    "image": "https://ipfs.io/ipfs/QmQ16venNrsStbb6zdJVSyCiYJ41A9ReiGPgy5K1UcGt6X",
    "price": "6.5 ETH"
  },
  {
    "id": "cyberkongz-172",
    "name": "CyberKongz #172",
    "image": "https://ipfs.io/ipfs/QmZjSkYfc6EXhZniYmPKB7xVChjW73ywHcpMJeUy6kNwso",
    "price": "5.4 ETH"
  },
  {
    "id": "cyberkongz-562",
    "name": "CyberKongz #562",
    "image": "https://ipfs.io/ipfs/QmYAByaVHu6qaZDDbQjY1yd7r83w8kmyqsH6U4K7Gf1aP6",
    "price": "7.0 ETH"
  },
    
  {
    "id": "cyberkongz-737",
    "name": "CyberKongz #737",
    "image": "https://ipfs.io/ipfs/QmdmpPoUnbZSf26HWAHyvFPk8Eh6SXb5n63uhCFwSUzpfr",
    "price": "4.8 ETH"
  },
  {
    "id": "cyberkongz-485",
    "name": "CyberKongz #485",
    "image": "https://ipfs.io/ipfs/QmagxDNgDjpsMDdAvYTzbrv3CuFPjGpjcEWMTR8RPEMXmt",
    "price": "6.9 ETH"
  },
  {
    "id": "cyberkongz-516",
    "name": "CyberKongz #516",
    "image": "https://ipfs.io/ipfs/QmXVwBN8rQsTyWRMqNAUmMPWSXeK4LE5R6gUXbBkffmzuT",
    "price": "5.3 ETH"
  },
  {
    "id": "cyberkongz-243",
    "name": "CyberKongz #243",
    "image": "https://ipfs.io/ipfs/QmdY3TJG5DPpN31g4XV2f39i28cygFQC5XwaEt5Bg8GNhg",
    "price": "7.2 ETH"
  },
  {
    "id": "cyberkongz-269",
    "name": "CyberKongz #269",
    "image": "https://ipfs.io/ipfs/QmRSmRyEUMYHWxsemhaS4y8k64DxVRBJ6McPSv7PE7xbEK",
    "price": "4.7 ETH"
  },
  {
    "id": "cyberkongz-523",
    "name": "CyberKongz #523",
    "image": "https://ipfs.io/ipfs/QmPXzZNyxjs2f8p3Cpf5z6WEEdCVnJhrB6pUE3UaCXZdB6",
    "price": "6.4 ETH"
  },
  {
    "id": "cyberkongz-622",
    "name": "CyberKongz #622",
    "image": "https://ipfs.io/ipfs/QmSEhmpxWMY1TEZT1G3s5sHWpvs8uc3Rz137RBbx566xrp",
    "price": "5.6 ETH"
  },
  {
    "id": "cyberkongz-882",
    "name": "CyberKongz #882",
    "image": "https://ipfs.io/ipfs/QmbNzRSe3PwpTxUXJUGr2uSAQQN6XY5yyQtNpiyoAKM21W",
    "price": "7.4 ETH"
  },
  {
    "id": "cyberkongz-323",
    "name": "CyberKongz #323",
    "image": "https://ipfs.io/ipfs/QmRWxcKabQw314PqQ4S15TNkUinDYjHnKZwB1hyPTC3pgj",
    "price": "4.9 ETH"
  },
  {
    "id": "cyberkongz-412",
    "name": "CyberKongz #412",
    "image": "https://ipfs.io/ipfs/QmSadQkZdYwfQN6sGTdZi3S945CQ43yrGUeS5CPFoaRPvG",
    "price": "6.7 ETH"
  },
  {
    "id": "cyberkongz-498",
    "name": "CyberKongz #498",
    "image": "https://ipfs.io/ipfs/QmUrrLJHa72TbFL3UQd9nzYhVXMJZ4S78dJdVu3ejXPKiu",
    "price": "5.1 ETH"
  },
  {
    "id": "cyberkongz-305",
    "name": "CyberKongz #305",
    "image": "https://ipfs.io/ipfs/QmWkDyPwvq7hREWtdVeAxLkNog8iz1MJ3eyhXWjR24hUCi",
    "price": "7.1 ETH"
  },
  {
    "id": "cyberkongz-403",
    "name": "CyberKongz #403",
    "image": "https://ipfs.io/ipfs/QmYuaBj3jYaRoyTSTstpNd1L8De5dgiXjFz9b3Gbs4ZxTy",
    "price": "4.6 ETH"
  },
  {
    "id": "cyberkongz-475",
    "name": "CyberKongz #475",
    "image": "https://ipfs.io/ipfs/QmdwsnfEZTWNeRuDLVpswNASqf6ySTKu2xBwAEGjZjwxJS",
    "price": "6.3 ETH"
  },
  {
    "id": "cyberkongz-289",
    "name": "CyberKongz #289",
    "image": "https://ipfs.io/ipfs/QmeKEvjUe55fK6UvDt1grSfKDuJB4BBwAQyHm31AKEQqDf",
    "price": "5.5 ETH"
  },
  {
    "id": "cyberkongz-812",
    "name": "CyberKongz #812",
    "image": "https://ipfs.io/ipfs/QmY27E2royZCBjwyn6ukYAiafr6hUvpGHyqctRvHqDybB1",
    "price": "7.3 ETH"
  },
  {
    "id": "cyberkongz-637",
    "name": "CyberKongz #637",
    "image": "https://ipfs.io/ipfs/QmWHnUJ71YxC4B5qM6fV1oP3vPQMyF7iDAUPgQQc1PMWu1",
    "price": "4.8 ETH"
  },
  {
    "id": "cyberkongz-140",
    "name": "CyberKongz #140",
    "image": "https://ipfs.io/ipfs/Qmf9KEVYc7Jih55iJk4tU4vfWT5bQ3sLYLHxWC8HmD8ERc",
    "price": "6.6 ETH"
  },
  {
    "id": "cyberkongz-361",
    "name": "CyberKongz #361",
    "image": "https://ipfs.io/ipfs/QmQudDb59T5ZTXM3LdCxfhJuuXwHZLBgDuquSKaKimAz1X",
    "price": "5.2 ETH"
  },
  {
    "id": "cyberkongz-558",
    "name": "CyberKongz #558",
    "image": "https://ipfs.io/ipfs/QmdJicu2fgWyCwKthJaDMT5Jfi6Vya38vsh5Z5efsZhVid",
    "price": "7.0 ETH"
  },
  {
    "id": "cyberkongz-561",
    "name": "CyberKongz #561",
    "image": "https://ipfs.io/ipfs/QmT5MwnpcktQbzK3fVKTsTSBZuuHigCniKmKM5pAoTkpy7",
    "price": "4.7 ETH"
  },
  {
    "id": "cyberkongz-350",
    "name": "CyberKongz #350",
    "image": "https://ipfs.io/ipfs/QmUUjyVWgTckJsvTVW9TQmNoxUMWRmExrRzaZXauGnv7ih",
    "price": "6.5 ETH"
  },
  {
    "id": "cyberkongz-866",
    "name": "CyberKongz #866",
    "image": "https://ipfs.io/ipfs/QmYGE3RiaLeki35vpQnrF46ScdK9MmgvpeDFUU2hwQbBkz",
    "price": "5.4 ETH"
  },
  {
    "id": "cyberkongz-949",
    "name": "CyberKongz #949",
    "image": "https://ipfs.io/ipfs/QmWZ9Pg5Fq8AV1aZ4C6v3Lo2C5xYDBAVeN3729orSYjh3h",
    "price": "7.2 ETH"
  },
  {
    "id": "cyberkongz-335",
    "name": "CyberKongz #335",
    "image": "https://ipfs.io/ipfs/QmUdXXamMZjLdq9a9VumzRD1wjUHEA9ULs11gxQNHMFG87",
    "price": "4.9 ETH"
  },
  {
    "id": "cyberkongz-978",
    "name": "CyberKongz #978",
    "image": "https://ipfs.io/ipfs/QmQv9Nqix2saxy4KWvVvbPHwvh8BjFWvy5iht4GiDmhmrw",
    "price": "6.8 ETH"
  }



];